/**
 * ハッシュ付きのリンクをスムーススクロールで移動します。
 * ページ読み込み時にハッシュと同じid属性があれば、その要素に移動します。
 * https://github.com/tsuyoshiwada/sweet-scroll
 */
import SweetScroll from 'sweet-scroll';
import MediaQuery from '../lib/MediaQuery';

export default function v1JsSmoothScroll() {
  let headerElement;
  MediaQuery.matches('lg', matches => {
    if (matches) {
      headerElement = '#v1-header__head';
    } else {
      headerElement = '#v1-header__body';
    }
  });

  // クラスで指定する場合。
  // const baseNameClass = 'js-SmoothScroll';
  // ハッシュ付きリンクに指定する場合。
  const baseNameAttr =
    'a[href*="#"]:not([href*="/"]):not([href="#"]):not(#v1-back-to-top):not(.js-disabledSmoothScroll)';

  const scroller = new SweetScroll({
    trigger: baseNameAttr, // トリガーとなる要素をCSSセレクタで指定
    header: headerElement, // 固定ヘッダをCSSセレクタで指定
    duration: 1000, // アニメーション再生時間のミリ秒
    easing: 'easeOutQuint', // イージングのタイプ
    offset: 0, // スクロール位置のオフセット
    vertical: true, // 垂直方向のスクロールを許可する
    horizontal: false, // 水平方向のスクロールを許可する
    cancellable: true, // ホイールやタッチイベント発生時にスクロールを停止する
    updateURL: true, // スクロール完了後にURLを更新する
    preventDefault: true, // コンテナ要素のクリックイベントを防止する
    stopPropagation: true, // コンテナ要素のバブリングを防止する

    // スクロール先要素にフォーカスを変更する
    before(offset, $trigger, scrollElement) {
      const destination = document.getElementById(scrollElement.ctx.hash.replace('#', ''));
      destination.setAttribute('tabindex', '-1');
      setTimeout(() => {
        destination.focus();
      }, 0);
    },
  });

  /**
   * ページ読み込み時にURLのハッシュと同じid属性があれば、その要素まで移動する。
   */
  // URLにハッシュがなければ中止する
  let locationHash = window.location.hash;
  const hashExists = locationHash.length >= 1;
  if (!hashExists) {
    return;
  }

  // ページ内に特定の要素があったら処理を中止する
  const excludedSelector = ['#tastesofjapan .tabBtn a'];
  const excludedElm = excludedSelector.filter(selector => {
    const elm = document.querySelector(selector);
    return elm;
  });
  const excludedExists = excludedElm.length !== 0;
  if (excludedExists) {
    return;
  }

  const scrollElement = document.getElementById(locationHash.substr(1));
  const needsInitialScroll = scrollElement != null;
  if (!needsInitialScroll) {
    return;
  }

  window.location.hash = '';

  window.addEventListener('load', () => {
    setTimeout(() => {
      scroller.to(locationHash, { updateURL: 'replace' });
    }, 0);
  });

  // アドレスバーでハッシュを変更したら、スムーススクロールを実行する
  window.addEventListener('hashchange', event => {
    const { newURL } = event;
    const regexp = /#$/;
    const isFirstChange = regexp.test(newURL);

    if (!isFirstChange) {
      locationHash = window.location.hash;
      scroller.to(locationHash, { updateURL: 'replace' });
    }
  });
}
